import { CSSProperties } from 'react'
import styled from 'styled-components'

export const WrapperCard = styled.div<{ backgroundColor?: string }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  gap: 24px;
`
export const titleStyle: CSSProperties = {
  color: '#000',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '32px'
}

export const textFooterStyle: CSSProperties = {
  color: 'rgba(0, 0, 0, 0.85)',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '22px'
}

export const alertStyle: React.CSSProperties = {
  marginBottom: 16
}

export const successTransitionStyle: React.CSSProperties = {
  transition: 'all 0.3s ease-in-out',
  opacity: 1,
  transform: 'translateY(0)',
  overflow: 'hidden'
}
